<template>
  <img v-if="objectUrl" :src="objectUrl" :alt="alt" />
  <div
    v-else
    :class="['flex items-center justify-center bg-gray-200 text-gray-400 text-xs', failed ? '' : 'animate-pulse']"
    role="img"
    :aria-label="alt"
  >
    <i v-if="failed" class="fa-regular fa-image"></i>
  </div>
</template>

<script>
import http from '@/service/client';

// Las variantes de imagen del blog están detrás del JWT, así que un <img src> directo recibe 401.
// Se descargan con el cliente axios (que agrega Authorization) y se muestran como blob URL.
// La caché evita volver a pedir la misma miniatura al recargar la lista; son archivos chicos.
const cache = new Map();

const fetchObjectUrl = (url) => {
  if (!cache.has(url)) {
    const request = http
      .get(url, { responseType: 'blob' })
      .then((response) => URL.createObjectURL(response.data))
      .catch((error) => {
        cache.delete(url);
        throw error;
      });
    cache.set(url, request);
  }
  return cache.get(url);
};

export default {
  name: 'AuthImage',
  props: {
    src: { type: String, default: '' },
    alt: { type: String, default: '' },
  },
  data() {
    return { objectUrl: '', failed: false };
  },
  watch: {
    src: { immediate: true, handler: 'load' },
  },
  methods: {
    async load(src) {
      this.objectUrl = '';
      this.failed = false;
      if (!src) {
        this.failed = true;
        return;
      }
      try {
        const objectUrl = await fetchObjectUrl(src);
        // Ignora respuestas de un src anterior si cambió mientras se descargaba.
        if (src === this.src) this.objectUrl = objectUrl;
      } catch {
        if (src === this.src) this.failed = true;
      }
    },
  },
};
</script>
